import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import {
  GetReceiptRulesResponse,
  MutateReceiptRulesResponse,
  ReceiptRulesBody,
} from 'src/queries/organizations/receiptRules/receiptRules.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * RequestConfig.Default mirrors all three legacy thunks'
 * `selectAuthedJsonApiRequestConfig` usage.
 */
export const getReceiptRules = async (
  orgId: string,
): Promise<GetReceiptRulesResponse> => {
  return getResponseData(
    axios.get<GetReceiptRulesResponse>(
      `/organizations/${orgId}/receiptrules`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postReceiptRules = async (
  orgId: string,
  body: ReceiptRulesBody,
): Promise<MutateReceiptRulesResponse> => {
  return getResponseData(
    axios.post<MutateReceiptRulesResponse>(
      `/organizations/${orgId}/receiptrules`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const putReceiptRules = async (
  orgId: string,
  body: ReceiptRulesBody,
): Promise<MutateReceiptRulesResponse> => {
  return getResponseData(
    axios.put<MutateReceiptRulesResponse>(
      `/organizations/${orgId}/receiptrules`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
